import ReadingSummary from './ReadingSummary';

export default ReadingSummary;
